import React from 'react';
import { connect } from 'react-redux';

// IMPORTS DE ESTILOS E IMAGENES:
import './style.scss';


/**
 * Representa el componente container Home
 *
 * @class HomePage
 * @extends {React.Component}
 */
export class HomePage extends React.Component {
  render() {
    return (<div></div>);
  }
}

HomePage.defaultProps = {
};

HomePage.propTypes = {
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
